export default {
  //   name: [
  //     {
  //       required: true,
  //       message: '请选择产品',
  //       trigger: 'blur',
  //     },
  //   ],
  version: [
    {
      required: true,
      message: '请输入版本号',
      trigger: 'blur',
    },
    {
      validator: (cell, val) => {
        return new Promise((resolve, reject) => {
          const pert = /^[V]?([0-9]|[\.])+$/
          if (pert.test(val)) {
            resolve()
          } else {
            reject('请输入正确的版本号格式,例如V1.0.1')
          }
        })
      },
    },
  ],
  releaseTime: [
    {
      required: true,
      message: '请选择时间',
      trigger: 'blur',
    },
  ],
  content: [
    {
      required: true,
      message: '请输入更新内容',
      trigger: 'blur',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/pages/index/views/UpdateJournal/editRules.js